import { FC } from 'react';
import shallow from 'zustand/shallow';
import { useDialog } from '@/logic/state';
import { ConfirmDialog } from '@/components/shared/confirm-dialog';

export const ChangeShowtimeConfirmDialog: FC = () => {
  const [dialog, setDialog] = useDialog(s => [s.dialog, s.setDialog], shallow);

  return (
    <ConfirmDialog
      buttonId='change-showtime-confirm-dialog'
      img='/icons/booking/cancel-seats-selection-icon.svg'
      widthImage='149px'
      heightImage='103px'
      altImage='alt.cancel_selection_seats_icon'
      title='booking.cancel_seats_selection'
      description='booking.change_showtime_confirm_dialog.description'
      handleOkayClick={dialog?.changeShowtimeConfirmDialogPayload?.handleOkayClick}
      handleCloseClick={() => setDialog({})}
    />
  );
};
